import { useApi } from "@/shared/api";
import { useToastNotifications } from "@/shared/hooks/useToastNotifications";
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type { AxiosError, AxiosResponse } from "axios";
import type { VerdictCandidateRequest } from "./api.dto";
import type { PaginatedResponse, PaginationRequest } from "@/shared/types";
import type { Candidate } from "../model";
import { filterObjectKeys } from "@/shared/lib/utils";

export const useVerdictContacts = () => {
  const { api } = useApi();
  const { onSuccess, onError } = useToastNotifications({
    toast: {
      success: {
        description: "Вынесен вердикт по заявке.",
      },
    },
    refetchQueries: ["myCandidates"],
  });

  return useMutation<AxiosResponse, AxiosError, VerdictCandidateRequest>({
    mutationKey: ["myCandidates"],
    mutationFn: (data) => {
      return api.patch(`/candidates/${data.id}/verdict`, {
        verdict: data.verdict,
      });
    },
    onSuccess,
    onError,
  });
};

export const useMyCandidates = (
  props: PaginationRequest & { id: string; enabled: boolean },
) => {
  const { api } = useApi();

  return useQuery<PaginatedResponse<Candidate>>({
    queryKey: ["myCandidates", filterObjectKeys(props, ["enabled"])],
    queryFn: async () => {
      try {
        const response = await api.get(`/candidates/user/${props.id}`, {
          params: filterObjectKeys(props, ["enabled", "id"]),
        });

        return response.data;
      } catch (e) {
        console.error(`${e}`);
      }
    },
    ...{ enabled: props.enabled },
  });
};

export const useSuspenseCandidates = (props: PaginationRequest) => {
  const { api } = useApi();
  const params = filterObjectKeys(props);

  return useSuspenseQuery<PaginatedResponse<Candidate>>({
    queryKey: ["candidates", params],
    queryFn: async () => {
      try {
        const response = await api.get("/candidates/", {
          params,
        });

        return response.data;
      } catch (e) {
        console.error(`${e}`);
      }
    },
  });
};

export const useCandidates = (props: PaginationRequest) => {
  const { api } = useApi();
  const params = filterObjectKeys(props);

  return useQuery<PaginatedResponse<Candidate>>({
    queryKey: ["candidates", params],
    queryFn: async () => {
      try {
        const response = await api.get("/candidates/", {
          params,
        });

        return response.data;
      } catch (e) {
        console.error(`${e}`);
      }
    },
  });
};
